module.exports = __webpack_public_path__ + "img/744.cbce2474.jpg";